/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Auth_PlaceholderInputs */

const en_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const fr_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facultatif`)
};

const de_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const it_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzionale`)
};

const ru_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необязательный`)
};

const es_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional`)
};

const zh_cn2_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选修的`)
};

const ja_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプション`)
};

const hi_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वैकल्पिक`)
};

const pt_pt2_live_caption_auth_placeholder = /** @type {(inputs: Live_Caption_Auth_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional`)
};

/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Live_Caption_Auth_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_auth_placeholder = /** @type {((inputs?: Live_Caption_Auth_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Auth_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_auth_placeholder(inputs)
	if (locale === "de") return de_live_caption_auth_placeholder(inputs)
	if (locale === "it") return it_live_caption_auth_placeholder(inputs)
	if (locale === "ru") return ru_live_caption_auth_placeholder(inputs)
	if (locale === "es") return es_live_caption_auth_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_auth_placeholder(inputs)
	if (locale === "ja") return ja_live_caption_auth_placeholder(inputs)
	if (locale === "hi") return hi_live_caption_auth_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_auth_placeholder(inputs)
	return en_live_caption_auth_placeholder(inputs)
});